import React from 'react';
import { useFormContext } from 'react-hook-form';

import { LayoutDataType } from '../../types';

import { ScreenBodyShape as ScreenBodyShapeFemale } from './Female';
import { ScreenBodyShape as ScreenBodyShapeMale } from './Male';

export const ScreenBodyShape: React.FC = () => {
  const form = useFormContext<LayoutDataType>();
  const gender = form.watch('gender');

  if (gender === 'male') {
    return <ScreenBodyShapeMale />;
  }

  return <ScreenBodyShapeFemale />;
};
